<script setup>
// TODO: Deprecate this component
import { ref } from 'vue';

const emit = defineEmits(['update:modelValue', 'update:focused']);
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);
const statuses = [
    { title: 'By Weight', value: 'Lb' },
    { title: 'Volumetric', value: 'CF' }
];
</script>

<template>
    <v-select
        v-model="selected"
        :items="statuses"
        :label="hideLabel ? '' : $t('Dimensional Factor')"
        density="compact"
        hide-details
        clearable
        persistent-clear
        @update:modelValue="emit('update:modelValue', selected)"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </v-select>
</template>
